import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Form, FormGroup, Label, Input, Button, FormText, Row, Col
} from 'reactstrap';

const AddEditCategoryModal = ({
  mode,
  open,
  onClose,
  formik,
}) => {
  const isEditMode = mode === 'edit';

  const getFieldValue = (field, defaultValue = '') => {
    return formik.values[field] ?? defaultValue;
  };

  const getFieldError = (field) => {
    return formik.touched[field] && formik.errors[field] ? formik.errors[field] : null;
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    formik.setFieldValue(name, value);
  };

  const handleFieldBlur = (e) => {
    const { name } = e.target;
    formik.setFieldTouched(name, true);
  };

  return (
    <Modal isOpen={open} toggle={onClose} size="md">
      <Form onSubmit={formik.handleSubmit}>
        <ModalHeader toggle={onClose}>
          {isEditMode ? 'Edit Category' : 'Add Category'}
        </ModalHeader>

        <ModalBody>
          <Row className="mb-3">
            <Col md={12}>
              <FormGroup>
                <Label for="name" style={{ fontSize: '0.875rem' }}>Name *</Label>
                <Input
                  id="name"
                  name="name"
                  value={getFieldValue('name')}
                  onChange={handleFieldChange}
                  onBlur={handleFieldBlur}
                  disabled={formik.isSubmitting}
                  invalid={!!getFieldError('name')}
                  required
                />
                {getFieldError('name') && (
                  <FormText color="danger">{getFieldError('name')}</FormText>
                )}
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            color="secondary"
            outline
            onClick={onClose}
            disabled={formik.isSubmitting}
          >
            Cancel
          </Button>

          <Button
            type="submit"
            color="primary"
            disabled={formik.isSubmitting}
          >
            {formik.isSubmitting ? 'Saving...' : isEditMode ? 'Update' : 'Save'}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};
export { AddEditCategoryModal };
